import { render } from "./DetectionManagement.vue?vue&type=template&id=085e2afe&scoped=true"
import script from "./DetectionManagement.vue?vue&type=script&lang=js"
export * from "./DetectionManagement.vue?vue&type=script&lang=js"

import "./DetectionManagement.vue?vue&type=style&index=0&id=085e2afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085e2afe"]])

export default __exports__